import * as Joi from 'joi';

export interface SpersExamFeeFormData {
  gstPercent: number;
  gstInclusive: string;
  registrationFee: number;
  lateRegistrationFee: number;
  firstTimerRegistrationFee: number;
  secondTimerRegistrationFee: number;
  firstTimerLateFee: number;
  secondTimerLateFee: number;
}

export const SpersExamFeeSchema = Joi.object({
  gstPercent: Joi.number().required().max(999.99).messages({
    'any.required': `GST Percent is not allowed to be empty.`,
    'number.base': `GST Percent is not allowed to be empty.`,
    'number.max': `GST Percent is not allowed to more than 3 digit.`,
  }),
  gstInclusive: Joi.string().required().messages({
    'any.required': `Please select if GST is inclusive.`,
  }),
  registrationFee: Joi.number().required().max(99999.99).messages({
    'any.required': `Registration Fee is not allowed to be empty.`,
    'number.base': `Registration Fee is not allowed to be empty.`,
    'number.max': `Registration Fee is not allowed to more than 5 digit.`,
  }),
  lateRegistrationFee: Joi.number().required().max(99999.99).messages({
    'any.required': `Late Registration Fee is not allowed to be empty.`,
    'number.base': `Late Registration Fee is not allowed to be empty.`,
    'number.max': `Late Registration Fee is not allowed to more than 5 digit.`,
  }),
  firstTimerRegistrationFee: Joi.number().required().max(99999.99).messages({
    'any.required': `First-Timer Registration Fee is not allowed to be empty.`,
    'number.base': `First-Timer Registration Fee is not allowed to be empty.`,
    'number.max': `First-Timer Registration Fee is not allowed to more than 5 digit.`,
  }),
  secondTimerRegistrationFee: Joi.number().required().max(99999.99).messages({
    'any.required': `2nd-Timer Registration Fee is not allowed to be empty.`,
    'number.base': `2nd-Timer Registration Fee is not allowed to be empty.`,
    'number.max': `2nd-Timer Registration Fee is not allowed to more than 5 digit.`,
  }),
  firstTimerLateFee: Joi.number().required().max(99999.99).messages({
    'any.required': `First-Timer Late Registration Fee is not allowed to be empty.`,
    'number.base': `First-Timer Late Registration Fee is not allowed to be empty.`,
    'number.max': `First-Timer Late Registration Fee is not allowed to more than 5 digit.`,
  }),
  secondTimerLateFee: Joi.number().required().max(99999.99).messages({
    'any.required': `2nd-Timer Late Registration Fee is not allowed to be empty.`,
    'number.base': `2nd-Timer Late Registration Fee is not allowed to be empty.`,
    'number.max': `2nd-Timer Late Registration Fee is not allowed to more than 5 digit.`,
  }),
});
